import React, { useState, useEffect } from 'react';
import { GuestListTableContainer } from './communication.style';
import { AppInputField, AppInputFieldBtn } from '../../../../widget/styledComponents/input_field.style';
import { gql, useMutation } from '@apollo/client';
import { Heading, Spinner, Tab, TabNavigation, toaster } from 'evergreen-ui';
import ReactQuill from 'react-quill';
import ImageUpload from './image_uploader';
import DocumentUpload from './document_uploader';

export const COMMUNICATION_UPDATE = gql`
  mutation Communication_update($communicationId: ID!, $title: String!, $body: String!, $image: String!, $docs: [String!]!) {
    communication_update(communicationId: $communicationId, title: $title, body: $body, image: $image, docs: $docs) {
      code
      success
      error
      data {
        _id
        title
        image
        docs
        body
        type
        author {
          name
          email
        }
        hasBeenRead
        facility
        createdAt
        authorType
        id
        admin
        facilityManager
      }
    }
  }
`;

function CommunicationOnePageWidget(props) {
  const tabs = React.useMemo(() => ['Announcement', ''], []);
  const [selectedTypeIndex, setSelectedTypeIndex] = React.useState();
  const [updateCommunication, { loading }] = useMutation(COMMUNICATION_UPDATE);
  const [editBanner, setEditBanner] = useState(false);
  const [addMoreDocumen, setAddMoreDocumen] = useState(false);
  const [postTitle, setPostTitle] = useState(props.comOne.title);
  const [editorHtml, setEditorHtml] = useState(props.comOne.body);
  const [uploadedImageUrl, setUploadedImageUrl] = useState(null);
  const [uploadedDocumentUrls, setUploadedDocumentUrls] = useState([]);

  const handleChange = (html) => {
    setEditorHtml(html);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // const  datatosend =;
    
    // console.log(datatosend)
    updateCommunication({ 
        // variables: datatosend
        variables: {
          communicationId: props.comOne._id,
          title: postTitle,
          body: editorHtml,
          image: uploadedImageUrl,
          docs: uploadedDocumentUrls
        } 
      })
      .then(() => {
        toaster.success("Post Updated");
        window.location.reload();
      })
      .catch((error) => {
        toaster.danger(error.message);
      });
  };

  const handleUploadComplete = (url) => {
    setUploadedImageUrl(url);
  };

  const handleUploadComplete2 = (urls) => {
    setUploadedDocumentUrls((prevItems) => [...prevItems, ...urls]);
  };

  const handleOnchangeTitle = (event) => {
    setPostTitle(event.target.value);
  };

  useEffect(() => {
    setUploadedImageUrl(props.comOne.image);
    setUploadedDocumentUrls(props.comOne.docs);
  }, [props.comOne]);

  return (
    <div>
      <br />
      <form onSubmit={handleSubmit}>
        <GuestListTableContainer>
          <Heading size={600} marginTop={28}>
            Pick communication type
          </Heading>
          <TabNavigation className='z-depth-0 transparent'>
            {tabs.map((tab, index) => (
              <Tab
                is="a"
                isSelected={selectedTypeIndex === index}
                key={tab}
                onClick={() => setSelectedTypeIndex(index)}
              >
                {tab}
              </Tab>
            ))}
          </TabNavigation>

          <Heading size={600} marginTop={28}>
            Title
          </Heading>
          <AppInputField
            type="text"
            value={postTitle}
            onChange={handleOnchangeTitle}
            required
          />

          <Heading size={600} marginTop={28}>
            Body
          </Heading>
          <div>
            <ReactQuill
              theme="snow"
              onChange={handleChange}
              placeholder='Type in your post here'
              value={editorHtml}
              required
            />
          </div>

          <Heading size={600} marginTop={28}>
            <div className='row'>
              <div className='col s12 m4'>Banner</div>
              <div className='col s12 m4'>
                <button
                  type="button"
                  onClick={() => setEditBanner(!editBanner)}
                  style={{
                    textTransform: "capitalize",
                    marginTop:"10px",
                    marginLeft: "10px",
                    cursor: "pointer",
                    background: "none",
                    border: "none",
                    color:`${editBanner?"red" :"blue"}`, // Styled to resemble a link
                  }}
                >
                  <small>{editBanner ? 'cancel edit' : 'edit'}</small>
                </button>
              </div>
              <div className='col s12 m4'></div>
            </div>
          </Heading>

          {!editBanner && (
            <div className='row'>
              <div className='col s12 m4'>
                <ul className="collection">
                  <li className="collection-item">
                    <a href={props.comOne.image} target="_blank" rel="noreferrer noopener" style={{ 
                      display: 'block',
                      
                     }}>
                      <div
                        style={{
                          color:"#4F46E5 !important"
                        }}
                      >Click to view banner
                        <span className="secondary-content">
                          <i className="material-icons">image</i>
                        </span>
                      </div>
                    </a>
                  </li>
                </ul>
              </div>
              <div className='col s12 m4'></div>
              <div className='col s12 m4'></div>
            </div>
          )}
          {editBanner && <ImageUpload onUploadComplete={handleUploadComplete} />}

          <Heading size={600} marginTop={28}>
            <div className='row'>
              <div className='col s12 m4'>Documents</div>
              <div className='col s12 m4'>
                <button
                  type="button"
                  onClick={() => setAddMoreDocumen(!addMoreDocumen)}
                  style={{
                    textTransform: "capitalize",
                    marginTop:"-10px",
                    marginLeft:"10px",
                    cursor: "pointer",
                    background: "none",
                    border: "none",
                    color: `${addMoreDocumen?"red":"blue"}`, // Styled to resemble a link
                  }}
                >
                  <small>{addMoreDocumen ? 'cancel edit' : 'Add document'}</small>
                </button>
              </div>
              <div className='col s12 m4'></div>
            </div>
          </Heading>
          {addMoreDocumen && <DocumentUpload onUploadComplete={handleUploadComplete2} />}

          {!addMoreDocumen && props.comOne.docs.map((url, index) => (
            <div className='row' key={index}>
              <div className='col s12 m4'>
                <ul className="collection">
                  <li className="collection-item">
                    <a href={url} target="_blank" rel="noreferrer noopener" style={{ 
                      display: 'block',
                      color:"#4F46E5 !important"
                      }}>
                      <div>Click to view document
                        <span className="secondary-content">
                          <i className="material-icons">attach_file</i>
                        </span>
                      </div>
                    </a>
                  </li>
                </ul>
              </div>
              <div className='col s12 m4'></div>
              <div className='col s12 m4'></div>
            </div>
          ))}
        </GuestListTableContainer>

        <div className="mt-50" style={{ width: "150px" }}>
          <AppInputFieldBtn
            disabled={loading}
            type='submit'
            className='center'
          >
            <center>
              {loading ? <Spinner /> : 'Update'}
            </center>
          </AppInputFieldBtn>
        </div>
      </form>
    </div>
  );
}

export default CommunicationOnePageWidget;
